import { useAuth0 } from '@auth0/auth0-react';
import { LoggingIn } from 'common/components/LoggingIn';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import { currentUserRole } from 'utility/cache';

export const AcceptInvitation: React.FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();
  const history = useHistory();

  const [invitation] = useQueryParam('invitation', StringParam);
  const [organization] = useQueryParam('organization', StringParam);

  useEffect(() => {
    if (isLoading) return;

    if (!invitation || !organization) {
      history.replace('/');
      return;
    }

    currentUserRole(undefined);

    loginWithRedirect({
      authorizationParams: { invitation, organization, screen_hint: 'signup' },
      appState: { returnTo: '/' },
    });
  }, [isLoading, invitation, organization, loginWithRedirect]);

  return <LoggingIn />;
};
